import React from 'react';
import styles from './MainPagePosts.css';

const blogUrl = 'https://trapeznikov.com/posts';

// Deliberately selected; the full archive remains on the separate blog app.
const posts = [
    {
        slug: 'freeing-10-of-your-agents-context-with-jev',
        title: 'Freeing 10% of Your Agent\'s Context with Jev',
        description: 'A fast decision model trims the tool output your coding agent never needs.',
        cover: 'jev-triage-context-meter-cover.png'
    },
    {
        slug: 'proactive-recall-for-coding-agents',
        title: 'Proactive Recall for Coding Agents',
        description: 'Why memory belongs in the harness, before the agent starts planning.',
        cover: 'proactive-recall-heatmap-cover.png'
    },
    {
        slug: 'make-your-agent-workflows-harness-agnostic',
        title: 'Make Your Agent Workflows Harness-Agnostic',
        description: 'One shared setup for skills, memory, and workflows across coding agents.',
        cover: 'harness-agnostic-terminal-cover.png'
    }
];

export default function MainPagePosts() {
    return (
        <section id="writing" className={styles.panel} aria-labelledby="writing-title">
            <div className={styles.header}>
                <h2 id="writing-title" className={styles.heading}>
                    <span className={styles.prompt} aria-hidden="true">&gt;</span> posts
                </h2>
                <a className={styles.archive} href={blogUrl}>all posts <span aria-hidden="true">→</span></a>
            </div>
            <div className={styles.posts}>
                {posts.map(post => (
                    <article key={post.slug} className={styles.post}>
                        <a className={styles.link} href={`${blogUrl}/${post.slug}`}>
                            <img className={styles.cover}
                                 src={`${blogUrl}/content/${post.cover}`}
                                 alt="" width="1920" height="1200" loading="lazy" />
                            <h3 className={styles.title}><span>{post.title}</span></h3>
                        </a>
                        <p className={styles.description}>{post.description}</p>
                    </article>
                ))}
            </div>
        </section>
    );
}
